import * as React from 'react';
import {connect} from 'react-redux';
import CommonTab from "../../../../parts/CommonTabClass";
import ToolButtons from "../../../../parts/ToolButtons";
import RemoveButton from "../../../../parts/removeBtn";
import {
	ActionDescriptorsTenderPublicationUnits,
	ActionTenderPublicationUnitDelete,
	ActionTenderPublicationUnitAdd,
	ActionTenderPublicationUnitEdit,
	ActionTenderPublications
} from "../../../../parts/actions";
import EditBtn from "../../../../parts/EditBtn";
import ColumnResizer from "react-column-resizer";
import AddUnit from './addUnit';
import {getItemData} from "../../../../parts/functions";
import Storege from "../../../../storage/storage";

class UnitsComponent extends CommonTab {

	orderFields = {
        "Plan Publication Unit Type": 'tenderpublicationunittypeid',
        "Units": 'unit'
    };


	addContentType = (object) => {
        ActionTenderPublicationUnitAdd('', object).then(data => {
            this.changePopupState();
            ActionTenderPublications(this.props.tenderid);
        });
    };

    editContentType = (object) => {
        ActionTenderPublicationUnitEdit(object.tenderpublicationunitdetailid, object).then(data => {
            this.changePopupState();
             ActionTenderPublications(this.props.tenderid);
        });
    };

    DeleteContentType = (id,descriptor) => {
        ActionTenderPublicationUnitDelete(id,descriptor).then(()=>{
        	ActionTenderPublications(this.props.tenderid);
        });
    };


	render() {
		const {items,tenderPublicationUnitsType,publication} = this.props
		 if (!tenderPublicationUnitsType.length) {
            ActionDescriptorsTenderPublicationUnits();
        }

		this.sortResults(items);
		return (
			<div>
                <div className={'custom-tool-bar'}>
                    <h3>Unit Details</h3>
                    <ToolButtons
                        actionType={this.changePopupType}
                        popupChange={this.changePopupState}
                        id={this.state.currentItemIndex}
                    />
                </div>
                <div className="scrolled ">
                    <table className={"table table-striped"} valign={"middle"}>
                        <thead>
                        {this.orderPanel()}
                        </thead>
	                    <tbody>
	                    {items.map((item, index) => {
                            return (
                                <tr key={index}  className={'list-group-item'}>
                                    <td  className={'flex-row'}>
                                        <RemoveButton
                                            descriptor={'REMOVE PLAN PUBLICATION'}
                                            action={this.DeleteContentType}
                                            id={item.tenderpublicationunitdetailid}
                                        />
                                        <EditBtn
                                            actionType={this.changePopupType}
                                            popupChange={this.changePopupState}
                                            change={this.setCurrentIndex}
                                            id={item.tenderpublicationunitdetailid}
                                        />
                                    </td>
                                    <td>
	                                    {getItemData(tenderPublicationUnitsType ? tenderPublicationUnitsType : [], 'tenderpublicationunittypeid', item.tenderpublicationunittypeid, 'tenderpublicationunittypename')}
	                                    &nbsp;/&nbsp;
	                                    {getItemData(tenderPublicationUnitsType ? tenderPublicationUnitsType : [], 'tenderpublicationunittypeid', item.tenderpublicationunittypeid, 'tenderpublicationunittypenameeng')}
                                    </td>
                                    <ColumnResizer className="columnResizer" minWidth={5}/>
                                    <td>
                                        {item.unit}
                                    </td>
                                </tr>
                            )
                        })}
	                    </tbody>
                    </table>
                </div>
				{this.state.popup ? <AddUnit
                    close={this.changePopupState}
                    itemList={items}
                    publication = {publication}
                    action={this.state.popupType === 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType === 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType === 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
			</div>
		)
	}
}

const mapStateToProps = (state , ownProps) => {
    return {
        tenderPublicationUnitsType: state.tenderPublicationUnits,
	    items : ownProps.items ? ownProps.items : []
    }
};
const Units = connect(mapStateToProps)(UnitsComponent);

export default Units;